import { createContext, Dispatch, SetStateAction } from 'react'

import type { CommonFormContextProps } from 'components/Form'
import type { WorkspacePrebidConfiguration } from 'features/globalSetup/types/workspacePrebidConfiguration'
import type { WorkspaceGeneralConfigurationFragmentFragment as WorkspaceGeneralConfiguration } from 'gql/graphql'

export const DefaultsContext = createContext<DefaultsContextType>({} as DefaultsContextType)

export type DefaultsContextType = CommonFormContextProps & {
  general?: {
    setWorkspaceGeneralConfiguration: Dispatch<
      SetStateAction<undefined | WorkspaceGeneralConfiguration>
    >
    workspaceGeneralConfiguration?: WorkspaceGeneralConfiguration
  }
  prebidStack?: {
    setWorkspaceConfig: Dispatch<SetStateAction<undefined | WorkspacePrebidConfiguration>>
    workspaceConfig?: WorkspacePrebidConfiguration
  }
}
